export default "__VITE_ASSET__BZ2FwkV1__"